import useViewTransitionNavigate from "Hooks/useViewTransitionNavigate";
import { TfiAlignRight } from "react-icons/tfi";
import Account from "../Account/Account";
import NavigateBar from "../NavigateBar/NavigateBar";
import logo from "./../../../assets/images/logo72.png";
import "./Navbar.scss";
export default function Navbar({ isOpen, toggle }) {
  const navigate = useViewTransitionNavigate();

  return (
    <div className="sticky top-0 z-10">
      <nav className="bg-mainLight h-16">
        <div className="max-w-6xl flex flex-row-reverse items-center justify-between h-full px-4 mx-auto">
          <div
            onClick={() => navigate("/control-panel")}
            className="flex items-center space-x-3 rtl:space-x-reverse"
          >
            <img className="w-14 drop-shadow-lg" src={logo} alt="" />
          </div>
          <div className="flex gap-4 items-center">
            <button
              onClick={() => toggle((prev) => !prev)}
              type="button"
              className="inline-flex _bg-green-500 hover:bg-green-700_ text-white shadow-md items-center p-2 w-10 h-10 justify-center text-sm  rounded-lg duration-500 lg:hidden"
              aria-expanded={isOpen}
            >
              <TfiAlignRight
                className={`text-2xl ${isOpen && "-scale-x-100"} `}
              />
            </button>
            <Account />
            {/* <Link
              to={"/control-panel/search"}
              className="inline-flex gap-2 bg-green-500 hover:bg-green-700 text-white shadow-md items-center p-2 w-fit h-10 justify-center text-sm  rounded-lg duration-500"
            >
              <RiSearchLine className={`text-2xl`} />{" "}
              <span className={`text-lg_ font-bold`}>بحث عن منتج</span>
            </Link> */}
          </div>
        </div>
      </nav>
      <NavigateBar />
    </div>
  );
}
